import lodash from 'lodash'
import moment from 'moment'
import { filter } from '../../../../utils/search'
import Base from '../base.store'

const baseUrl = '/api/v1/security/menu-sides'
const base = new Base(baseUrl)

const getPathOfDataItem = (dataItems, url) => {
    for (let i = 0; i < dataItems.length; ++i) {
        const dataItem = dataItems[i]
        if (dataItem.url === url) {
            return [dataItem]
        }
        if (dataItem.children) {
            const currentMenu = getPathOfDataItem(
                dataItem.children,
                url,
            )
            if (currentMenu.length > 0) {
                return [dataItem, ...currentMenu]
            }
        }
    }
    return []
}

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {
        dataItems: []
    }),
    getters: {
        ...base.getters,
        getPathOfDataItem: state => path => {
            return getPathOfDataItem(state.dataItems, path)
        },
        getCurrentRoutes: (state, getters) => (matchedArr) => {
            const currentRoutes = matchedArr.map((d) => {
                if (d?.instances?.default?.title) {
                    return {
                        url: d.path,
                        name: d?.instances?.default?.title,
                        children: []
                    }
                }
                const dbCurrentRoutes = getters.getPathOfDataItem(d?.path)
                return dbCurrentRoutes[dbCurrentRoutes.length - 1]
            }).filter((d) => d && d.name)
            return currentRoutes
        }
    },
    actions: {
        ...base.actions,
        getDataItem(context) {
            return base.request.get(`${baseUrl}/data-items`)
                .then(dataItems => {
                    context.commit('setDataItem', dataItems)
                    return dataItems
                })
        },
        cacheFindAll(context, { searchQuery }) {
            let force = false;
            const cacheDateResult = context.state.cacheDate.list;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true
            }
            const where = [
                { name: 'name', operator: 'like', value: searchQuery },
            ]
            const sort = [{ name: 'seq', type: 'ASC' }]
            const list = context.state.list || []
            if (list.length > 0 && !force) {
                return filter({ list, where, sort })
            }
            return context.dispatch('findAll', { criteria: { select: ['*'] } })
                .then(list => filter({ list, where, sort }))
        },
    },
    mutations: {
        ...base.mutations,
        setDataItem(state, dataItems) {
            state.dataItems = dataItems
        }
    },
}
